import api from '@pray/shared/utils/api';

export type SuperFunnelContractAuditRow = {
  id: string;
  field_name: string;
  old_value: string | null;
  new_value: string | null;
  actor_user_id: number | null;
  source: string;
  reason: string | null;
  prev_hash: string | null;
  row_hash: string;
  created_at: string;
};

export type GetSuperFunnelContractAuditParams = {
  contractId: string;
  limit?: number;
  offset?: number;
};

export type GetSuperFunnelContractAuditResponse = {
  responded_at: string;
  object: 'list';
  data: SuperFunnelContractAuditRow[];
  data_count: number;
  last_item_identifier: number | null;
  total: number;
  limit: number;
  offset: number;
};

export const getContractAudit = async ({
  contractId,
  limit,
  offset,
}: GetSuperFunnelContractAuditParams): Promise<GetSuperFunnelContractAuditResponse> => {
  const params: Record<string, number> = {};

  if (limit !== undefined) params.limit = limit;
  if (offset !== undefined) params.offset = offset;

  const url = `/web/studio/superfunnel/contracts/${contractId}/audit`;
  const response = await api.executeGetRequest(url, params);

  return response.data as GetSuperFunnelContractAuditResponse;
};
